export enum REQUEST_METHOD {
	POST = 'post',
	GET = 'get',
	PUT = 'put',
	PATCH = 'patch',
	DELETE = 'delete',
}